// @flow
import * as React from 'react';
// $$FlowIssue
import { forwardRef } from 'react';
import Textarea from 'react-textarea-autosize';

export const AnswerTextarea = forwardRef(function AnswerTextarea(
  props: *,
  ref
) {
  const { rows, style, ...rest } = props;
  return (
    <Textarea
      minRows={props.rows || 2}
      className="form-control mb3"
      style={{
        resize: 'none',
        ...style,
      }}
      {...rest}
      ref={ref}
    />
  );
});



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/AnswerTextarea.js